import React, {useCallback} from 'react';
import {useSelector} from 'react-redux';
import {useVariables} from '../../assets/objects/Variables';
import VariableDropdown from '../variableDropdown/VariableDropdown';
import ReactQuill from 'react-quill';
import {DirectionProvider} from '../whatsAppTemplateEditor/context/DirectionContext';

interface QuillVariablesDropdownProps {
    quillRef: React.RefObject<ReactQuill>;
    direction?: 'ltr' | 'rtl';
    remainingChars: number;
    variablesType?: string;
    dataCy?: string;
}

function QuillVariablesDropdown({
    quillRef,
    direction = 'rtl',
    remainingChars,
    variablesType = '',
    dataCy = 'quill-variables-dropdown'
}: QuillVariablesDropdownProps) {
    const {defaultVariables, disabledVariables} = useVariables(variablesType);
    const eventType = useSelector((s: any) => s.event?.type || '');

    const handleInsertVariable = useCallback((variableKey: string) => {
        const variable = defaultVariables[variableKey];
        if(!variable) return;
        
        const quill = quillRef.current?.getEditor();
        if(!quill) return;
        
        const range = quill.getSelection(true);
        if(range) {
            quill.insertText(range.index, ' ');
            quill.insertEmbed(range.index + 1, 'variable', [variableKey, variable]);
            quill.insertText(range.index + 2, ' ');
            quill.setSelection(range.index + 3, 0);
        }
    }, [quillRef, defaultVariables]);

    return (
        <DirectionProvider direction={direction}>
            <VariableDropdown
                onInsertVariable={handleInsertVariable}
                defaultVariables={defaultVariables}
                disabledVariables={disabledVariables}
                eventType={eventType}
                remainingChars={remainingChars}
                {...(dataCy ? {dataCy} : {})}
            />
        </DirectionProvider>
    );
}

export default QuillVariablesDropdown;
